import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import styles from './price-range.module.scss';

type Range = {
  from: string;
  to: string;
};

type PriceRangeProps = {
  onSubmit: (min: number, max: number) => void;
  range: Range;
  currentPriceFilter: { min: number | null; max: number | null };
};

const PriceRange: React.FC<PriceRangeProps> = (props) => {
  const { onSubmit, range, currentPriceFilter } = props;
  const { t } = useTranslation();

  const [min, setMin] = useState<number | null>(null);
  const [max, setMax] = useState<number | null>(null);

  useEffect(() => {
    setMin(currentPriceFilter.min);
    setMax(currentPriceFilter.max);
  }, [currentPriceFilter]);

  const submitPriceRangeForm = () => {
    onSubmit(min || 0, max || 0);
  };

  return (
    <form className={styles.priceRange}>
      <div className={styles.priceRange__col}>
        <input
          id="price-range-min"
          type="number"
          className={styles.priceRange__input}
          placeholder={t('CATALOG.FILTERS.PRICE.MIN')}
          value={min ?? ''}
          onChange={(e) => setMin(parseInt(e.target.value, 10))}
          aria-label={t('CATALOG.FILTERS.PRICE.MIN')}
        />
        <label className={styles.priceRange__label}>{range.from}</label>
      </div>
      <div className={styles.priceRange__col}>
        <input
          id="price-range-max"
          type="number"
          className={styles.priceRange__input}
          placeholder={t('CATALOG.FILTERS.PRICE.MAX')}
          value={max ?? ''}
          onChange={(e) => setMax(parseInt(e.target.value, 10))}
          aria-label={t('CATALOG.FILTERS.PRICE.MAX')}
        />
        <label
          htmlFor="price-range-max"
          className={styles.priceRange__label}
        >
          {range.to}
        </label>
      </div>
      <div className={styles.priceRange__col}>
        <Button
          id="price-range-submit"
          variant="secondary"
          size="small"
          onClick={submitPriceRangeForm}
        >
          {t('CATALOG.FILTERS.PRICE.OK')}
        </Button>
      </div>
    </form>
  );
};

export default PriceRange;
